import * as R from 'ramda';
// features
import PC from '../../permission/role-permission';
// helpers/constants
import * as G from '../../../helpers';
// icons
import * as I from '../../../svgs';
//////////////////////////////////////////////////

export const getTabs = (activeTab) => [
  {
    withCount: R.equals(activeTab, 0),
    text: G.getWindowLocale('titles:clo', 'CLO'),
  },
  {
    withCount: R.equals(activeTab, 1),
    text: G.getWindowLocale('titles:clo-by-tel', 'Order by Trip'),
  },
  {
    withCount: R.equals(activeTab, 1),
    text: G.getWindowLocale('titles:pivot-table', 'Pivot Table'),
  },
];

export const getListActionsOpt = (props) => {
  const { handlePrint, getXMLRequest, handleAddReferenceList } = props;

  const mainLightColor = G.getTheme('colors.light.mainLight');

  return [
    {
      action: getXMLRequest,
      permissions: [PC.CLO_READ, PC.CLO_WRITE],
      icon: I.downloadDocument(mainLightColor, 25, 25),
      text: G.getWindowLocale('actions:get-xml-file', 'Get XML File'),
    },
    {
      action: handlePrint,
      icon: I.printer(mainLightColor, 20, 20),
      permissions: [PC.CLO_READ, PC.CLO_WRITE],
      text: G.getWindowLocale('actions:print', 'Print'),
    },
    {
      type: 'massAction',
      action: handleAddReferenceList,
      permissions: [PC.CLO_REFERENCE_WRITE],
      icon: I.plusRound(mainLightColor, 25, 25),
      text: G.getWindowLocale('actions:add-reference', 'Add Reference'),
    },
  ];
};
